import script from "./deliOnceImg9.vue?vue&type=script&setup=true&lang=js"
export * from "./deliOnceImg9.vue?vue&type=script&setup=true&lang=js"

import "./deliOnceImg9.vue?vue&type=style&index=0&id=7e3c6f92&lang=less"

const __exports__ = script;

export default __exports__